/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Template_Empty_KeywordsInputs */



/**
* | output |
* | --- |
* | "Add keywords or phrases to monitor" |
*
* @param {Compliance_Template_Empty_KeywordsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_template_empty_keywords = /** @type {((inputs?: Compliance_Template_Empty_KeywordsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Template_Empty_KeywordsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fügen Sie Schlüsselwörter oder Phrasen zur Überwachung hinzu")
	return /** @type {LocalizedString} */ ("Add keywords or phrases to monitor")
});